/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from 'react-i18next';

interface ContainerDetailsHeaderProps {
  pageTitle: string;
  identifier: string;
  printLabel: string;
  onBack: () => void;
}

const ContainerDetailsHeader = ({
  pageTitle,
  identifier,
  printLabel,
  onBack,
}: ContainerDetailsHeaderProps) => {
  const { t } = useTranslation();

  return (
    // <div className="sticky top-[110px] z-40 bg-white border-b border-slate-200 px-8 py-4 flex items-center justify-between shadow-sm">
    //   <div className="flex items-center gap-4">
    //     <button
    //       onClick={onBack}
    //       className="w-12 h-12 rounded-2xl bg-white border border-slate-100 shadow-sm flex items-center justify-center text-slate-400 hover:text-[#2D3E50]"
    //     >
    //       <span className="material-symbols-outlined text-xl">
    //         {t("mediaPowder.icons.arrow_back")}
    //       </span>
    //     </button>

    //     <div>
    //       <h1 className="text-sm font-black text-slate-400 uppercase tracking-[0.25em]">
    //         {pageTitle}
    //       </h1>

    //       <span className="text-2xl font-black text-[#2D3E50]">
    //         {identifier}
    //       </span>
    //     </div>
    //   </div>

    //   <button className="px-9 py-2.5 bg-[#2D3E50] text-white rounded-xl">
    //     {printLabel}
    //   </button>
    // </div>



       <div className="sticky top-[110px] z-40 bg-white border-b border-slate-200 px-8 py-4 flex items-center justify-between shadow-sm">
          <div className="flex items-center gap-4">
            <button 
              onClick={onBack}
              className="w-12 h-12 rounded-2xl bg-white border border-slate-100 shadow-sm flex items-center justify-center text-slate-400 hover:text-[#2D3E50] hover:border-slate-300 hover:shadow-md transition-all group"
            >
              <span className="material-symbols-outlined text-xl group-hover:-translate-x-0.5 transition-transform">{t('mediaPowder.icons.arrow_back')}</span>
            </button>
            
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-4">
                <h1 className="text-sm font-black text-slate-400 uppercase tracking-[0.25em]">
                  {pageTitle}
                </h1>
              </div>
              <div className="flex items-center gap-4 mt-0.5">
                <span className="text-2xl font-black text-[#2D3E50] tracking-tight">
                  {identifier}
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <button className="relative group overflow-hidden px-9 py-2.5 bg-[#2D3E50] text-white rounded-xl font-black text-[12px] uppercase tracking-widest shadow-xl shadow-[#2D3E50]/20 hover:shadow-[#2D3E50]/30 transition-all active:scale-95 flex items-center gap-2 border-none outline-none focus:outline-none">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
              <span className="material-symbols-outlined text-2xl">{t('containerInventory.icons.print')}</span>
              {printLabel}
            </button>
          </div>
        </div>
  );
};

export default ContainerDetailsHeader;